module.exports = __webpack_public_path__ + "media/icons/offer-details-rolnicze@2x-4c0d59a0.png";